import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const url = e?.config?.url || "";
    if (e?.response?.status === 401 && !url.includes("/auth/") && window.location.pathname !== "/login") {
      window.location.assign("/login");
    }
    return Promise.reject(e);
  },
);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || "Request failed";
};

// A blob response hides the server's JSON error detail; read it back out.
export const blobErrMsg = async (e) => {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try {
      const detail = JSON.parse(await data.text()).detail;
      if (detail) return detail;
    } catch {
      /* fall through */
    }
  }
  return errMsg(e);
};
